import { useMutation, useQueryClient } from '@tanstack/react-query'
import { redeemApi } from '../../utils/api'
import { useAuth } from '../../contexts/AuthContext'

/**
 * 特典コードの引き換え（ProfilePage）。
 *
 * 成功時は真実源が2つあるため、両方を更新する:
 * - コード一覧（react-query の ['myCodes']）… 使用済み表示の更新
 * - user.plan の extra_hours / extra_sessions（AuthContext）… 残り表示の更新
 * 片方だけだと画面のどちらかが古いまま残る。useUpdateProfile と同じく hook 側で行い、
 * 呼び出し側の書き忘れが起きないようにする。
 *
 * 表示に使う granted_hours / granted_sessions とエラーの detail は、呼び出し側が
 * mutate(code, { onSuccess, onError }) で受ける（この onSuccess は真実源の整合のみを担う）。
 */
export function useRedeemCode() {
  const queryClient = useQueryClient()
  const { refreshUser } = useAuth()
  return useMutation({
    mutationFn: (code: string) => redeemApi.redeem(code),
    onSuccess: async () => {
      await refreshUser()
      queryClient.invalidateQueries({ queryKey: ['myCodes'] })
    },
  })
}
